// Worthify i18n — ES locale. Keys must mirror locales/en.js;
// missing keys fall back to English in useTranslation.
export const es = {
    // Header
    tagline: "¿Realmente merece la pena?",
    
    // Main heading
    mainHeading: "¡Conoce el valor real!",
    heroSubtext: "Una comprobación puede evitarte un error costoso.",
    
    // Input placeholders
    registrationPlaceholder: " ",
    pricePlaceholder: " ",
    priceHelperText: "Introduce el precio de oferta para comparar con el valor real",
    listingUrlPlaceholder: "Introduce la URL del anuncio (opcional)",
    vinPlaceholder: "ej. WAUZZZ4L1BD123456",
    vinHelperText: "Añadir VIN mejora la precisión del análisis de motor y riesgos",
    vinInvalid: "Formato VIN inválido (debe tener 17 caracteres)",
    vinTooltip: "El VIN ayuda a identificar el motor exacto y problemas ocultos",
    vinPreviewLoading: "Decodificando VIN…",
    vinPreviewDetected: "Detectado",
    vinPreviewUnknown: "No se pudo decodificar este VIN — el análisis funcionará igualmente",
    regHelperText: "Introduce cualquier número de matrícula",
    ctaHelperText: "Comprueba cualquier vehículo gratis ahora",
    
    // Buttons
    analyzeButton: "COMPROBAR AHORA",
    checkingVehicle: "Comprobando vehículo...",
    trustText: "Sin registro • Datos reales DVSA + DVLA • 🛡 More Than HPI Check • Veredicto instantáneo",
    downloadButton: "Descargar informe completo (solo £1)",
    generatingPdf: "Generando PDF...",
    newSearch: "← Nueva búsqueda",
    
    // Error messages
    errorEmptyRegistration: "Por favor, introduce una matrícula de vehículo",
    errorVehicleNotFound: "Vehículo no encontrado. Por favor, verifica el número de matrícula.",
    errorServiceUnavailable: "Servicio no disponible, por favor intenta de nuevo.",
    errorReportFailed: "Error al generar el informe. Por favor, intenta de nuevo.",
    
    // Results - Risk level
    riskLevel: "Nivel de riesgo",
    tickerFailedMots: "MOT FALLIDOS",
    tickerMiles: "MILLAS",
    tickerDangerous: "PELIGROSO",
    verdictWorthBuying: "BUENA OFERTA",
    verdictBeCareful: "PRECAUCIÓN",
    verdictAvoid: "EVITAR",
    verdictExplanationLow: "Historial MOT limpio. Compra segura.",
    verdictShortExplanationLow: "El historial se ve limpio. Inspecciona antes de pagar.",
    verdictShortExplanationMedium: "Problemas conocidos en el historial. Solo al precio adecuado.",
    verdictShortExplanationHigh: "Riesgos serios. Presupuesta reparaciones — o aléjate.",
    verdictShortExplanationScam: "Precio sospechosamente bajo. Trátalo como compra de alto riesgo.",
    verdictExplanationMedium: "Algunos problemas detectados. Inspecciona cuidadosamente.",
    verdictExplanationHigh: "Problemas graves detectados. Alto riesgo de reparaciones costosas.",
    verdictExplanationScam: "Esta oferta es muy sospechosa. Evita esta compra.",
    verdictSubtextLow: "Este precio parece razonable basado en el valor real.",
    verdictSubtextMedium: "Algo no parece bien. Inspecciona cuidadosamente antes de comprar.",
    verdictSubtextHigh: "Problemas graves detectados. Recomendamos encarecidamente evitar este vehículo.",
    verdictSubtextScam: "Esta oferta es muy sospechosa. Evita esta compra.",
    unlockFullReport: "DESBLOQUEAR INFORME DE RIESGO COMPLETO — SOLO £1",
    verdictIncludesLine1: "Incluye problemas ocultos, daños pasados y análisis de riesgo",
    verdictIncludesLine2: "Sin cuenta • Acceso instantáneo",
    verdictClarityLine: "El acceso es solo para esta sesión",
    verdictAvoidMistakes: "Evita errores costosos antes de comprar",
    verdictTrustedBy: "De confianza para compradores de coches en UK",
    verdictSecureLine: "Pago seguro • Datos reales del vehículo • Resultados instantáneos",
    whatYouUnlock: "Lo que desbloqueas",
    unlockItem1: "Riesgos ocultos de accidentes y daños",
    unlockItem2: "Detección de fraude de kilometraje",
    unlockItem3: "Costes de reparación exactos (£)",
    unlockItem4: "Ventaja de negociación — cuánto reducir el precio",
    unlockItem5: "Veredicto final: COMPRAR / NEGOCIAR / EVITAR",
    limitedOffer: "Precio de lanzamiento: £1",
    unlockCtaNew: "Desbloquear informe detallado por £1 →",
    poweredByLine: "Acceso único • Datos reales • Análisis experto",
    verdictHighCostWarning: "Esto podría costarte más que el propio coche.",
    verdictBackLink: "← Atrás",
    paymentProcessing: "Procesando pago...",
    checkingPayment: "Verificando estado del pago...",
    paymentConfirmedTitle: "¡Pago confirmado!",
    paymentConfirmedSub: "Preparando tu informe…",
    paymentVerifyTitle: "Comprobando el estado del pago…",
    paymentVerifySub: "Estamos confirmando tu pago con Stripe; normalmente tarda unos segundos. No cierres esta ventana.",
    paymentVerifySecure: "Pago seguro con Stripe",
    pdfDownloadedToast: "✓ Informe descargado",
    paymentVerifyingBanner: "Estamos verificando tu pago. El PDF se descargará automáticamente en cuanto se confirme el pago.",
    trustText: "Sin registro • Datos reales DVSA + DVLA • 🛡 More Than HPI Check • Veredicto instantáneo",
    redFlagsTitle: "Señales de alerta",
    noRedFlags: "Sin señales de alerta — historial limpio",
    yourAskingPrice: "Precio solicitado",
    marketMedianShort: "Valor real",
    suspiciousPrice: "Sospechoso — por debajo del mercado",
    unlockReportCta: "DESBLOQUEAR INFORME DE RIESGO COMPLETO — SOLO £1",
    pdfButtonSubtext: "Riesgos ocultos, costes de reparación y ventaja de negociación dentro",
    pdfButtonSubtext2: "Guárdalo, compártelo o úsalo al comprar el coche",
    lossWarning: "Podrías perder {amount}",
    negotiationPowerTitle: "Poder de Negociación",
    youCanNegotiate: "Puedes negociar",
    expertScriptLabel: "Guion de negociación experto",
    copyMessage: "Copiar mensaje",
    confirmedMotIssues: "defectos confirmados del MOT",
    expertSellerScript: "Hola — me interesa mucho el coche y estoy listo para decidir rápido. He hecho revisar el historial MOT de forma independiente por Worthify y el informe identifica {target} de reparaciones inmediatas y realistas: {issues}. No son cifras catastrofistas — es el coste real de arreglar lo que el MOT ya muestra. Para reflejarlo, necesitaría una reducción de precio de {target}.",
    expertSellerScriptClose: "Si podemos cerrar en {finalPrice}, podría resolver todo hoy.",
    worthifyExpertsSuggest: "Los expertos de Worthify sugieren negociar",
    askingPriceLabel: "Precio solicitado",
    realValueWorthifyLabel: "Valor real (Worthify)",
    realValueGvdLabel: "Valor de mercado (registro DVLA)",
    navHome: "Inicio",
    navAbout: "Acerca",
    navPricing: "Precios",
    navFaq: "FAQ",
    navContact: "Contacto",
    scoreAdjustedBadge: "Actualizado con datos premium",
    penaltyLabel_theft: "Reportado robado (PNC)",
    penaltyLabel_finance: "Financiación pendiente",
    penaltyLabel_mileage_anomaly: "Anomalía de kilometraje",
    penaltyLabelWriteOff: "Siniestro total registrado",
    penaltyLabelWriteOff_A: "Siniestro Cat A",
    penaltyLabelWriteOff_B: "Siniestro Cat B",
    penaltyLabelWriteOff_S: "Siniestro Cat S",
    penaltyLabelWriteOff_N: "Siniestro Cat N",
    penaltyLabelWriteOff_D: "Siniestro Cat D",
    penaltyLabelWriteOff_X: "Siniestro Cat X",
    penaltyPillAvoid: "Evitar",
    penaltyPillCaution: "Precaución",
    plainEnglishKickerAvoid: "VEREDICTO DEL REGISTRO",
    plainEnglishKickerCaution: "VEREDICTO DEL REGISTRO",
    simpleExplanationCardSubAvoid: "Toca para ver por qué bajó la puntuación",
    simpleExplanationCardSubCaution: "Toca para ver los hallazgos del registro",
    realValueWorthifySub: "con el estado actual y defectos",
    anchorFreeBadge: "Independiente · sin anclaje",
    marketValueLabel: "Valor de mercado",
    worthifyValuationTitle: "Tasación Worthify",
    worthifyExpertValuesThisCarAt: "Los expertos de Worthify tasan este coche en",
    withCurrentStateAndDefects: "con su estado actual y defectos",
    valuationGuidanceExplainer: "Idealmente el precio solicitado debería estar cerca de esta cifra. Mucho más alto significa que pagas de más. Mucho más bajo es una señal de alerta — daños ocultos, siniestro total o fraude. Pregunta antes de pagar.",
    negotiationGapExplainer: "Precio solicitado {asking}, valor real Worthify {realValue}. La diferencia de {gap} refleja el estado actual del coche y debe formar parte de tu negociación.",
    suspiciouslyCheapWarning: "{asking} frente a un valor real de {realValue} es anormalmente bajo. Los coches no se venden tan baratos sin motivo — verifica daños ocultos, documentos faltantes, financiación pendiente o siniestro total antes de pagar.",
    fairOrBelowExplainer: "{asking} frente a un valor real de {realValue} — es justo o incluso por debajo de la tasación Worthify. Sin margen de negociación significativo solo por la tasación, pero puedes usar los costes de reparación como palanca.",
    offTheAskingPrice: "de descuento sobre el precio solicitado",
    basedOnTheseIssues: "Basado en estos problemas confirmados",
    realisticRepairCost: "Coste realista de reparación",
    priceAboveMarket: "Precio solicitado por encima del valor de mercado",
    overMarketValue: "por encima del valor típico de mercado",
    negotiationExplainer: "Esta cifra refleja el coste real de reparar lo que el MOT realmente muestra, no escenarios pesimistas. Úsalo como punto de partida con el vendedor.",
    useThisToLowerPrice: "Usa esto para bajar el precio",
    totalRepairCostRange: "Rango total de costes de reparación",
    whatToSayToSeller: "Qué decirle al vendedor",
    verdictAvoidCar: "EVITA ESTE COCHE",
    verdictShortBad: "Valor muy pobre.",
    verdictShortMedium: "Procede con precaución.",
    verdictShortGood: "Compra sólida.",
    verdictSubShortBad: "Vehículo de alto riesgo.",
    verdictSubShortMedium: "Algunos problemas detectados.",
    verdictSubShortGood: "Vehículo con historial limpio.",
    scoreCardSubtext: "Costes de reparación \u00B7 Problemas ocultos \u00B7 Ventaja de negociación",
    potentialLossTitle: "Pérdida potencial al comprar este coche",
    overpricedByLabel: "Sobreprecio de",
    totalPotentialLoss: "Pérdida potencial total",
    totalEstimatedCost: "Coste total estimado",
    detailedPotentialCosts: "Riesgos y costes potenciales detallados",
    bigCostHeadline: "Inversión futura prevista: {amount}",
    expectedCostTitle: "Coste de propiedad esperado (12–24 meses)",
    expectedCostTypicalSuffix: "típico",
    expectedCostRangeSuffix: "rango realista",
    expectedCostRelativePrefix: "≈",
    expectedCostRelativeSuffix: "del valor del vehículo",
    expectedCostDriversTitle: "Motivos:",
    expectedCostWorstTitle: "Peor escenario",
    expectedCostWorstBody: "Hasta {amount}+ si ocurre una avería mayor ({worst_drivers}).",
    expectedCostFootnote: "Basado en historial MOT, patrones conocidos del motor y datos estadísticos de reparaciones.",
    expectedCostNoData: "Sin factores de coste relevantes en el historial por ahora — vigilar la próxima revisión.",
    costSubtitleExplanation: "Costes realistas a considerar en los próximos 12-24 meses — basados en defectos confirmados, la familia del motor y los puntos débiles típicos de la plataforma.",
    paywallTeaserLow: "Sobre el papel, parece razonable. El desglose completo muestra qué verificar antes de comprometerte.",
    paywallTeaserMedium: "Encontramos cosas que conviene saber antes de pagar. Desglose completo por £1.",
    paywallTeaserHigh: "Varios riesgos por delante. Mira cuánto van a costar antes que el vendedor.",
    paywallTeaserScam: "El precio parece demasiado bueno. Desglose completo — antes de transferir un euro.",
    paywallTeaserCTA: "Desbloquear el informe completo — £1",
    expertSellerScriptNoHistory: "Hola — el coche me interesa seriamente. Worthify ha hecho una valoración independiente basada en la familia del motor, la fiabilidad de la plataforma y el estado actual — el valor realista es {realValue}. Para que sea justo, necesitaría una reducción de {target}.",
    expertSellerScriptValuationOnly: "Hola — me gustaría cerrar esta semana. La valoración independiente de Worthify — motor, plataforma y estado — da {realValue}. Estaría listo para pagar esa cantidad hoy.",
    whyScoreTitle: "Por qué esta puntuación",
    whyScoreNoHistorySub: "Sin historial ITV, la puntuación se apoya en datos de motor y plataforma:",
    whyScoreWithHistorySub: "Estos factores la determinan:",
    whyScoreFactorEngine: "Riesgo de familia de motor",
    whyScoreFactorPlatform: "Riesgo de plataforma del modelo",
    whyScoreFactorHistory: "Patrón histórico ITV",
    whyScoreFactorUsage: "Perfil de uso / kilometraje",
    whyScoreFactorSafety: "Resultado crash-test",
    whyScoreNoHistoryHint: "Los coches nuevos sin historial empiezan más bajo porque aún no vemos cómo se ha conducido y mantenido este vehículo concreto — sólo cómo se comportan en promedio el motor y la plataforma.",
    familyDeltaBetter: "Tu {make_model} obtiene {pts} puntos mejor que la media de {family} ({n} coches analizados).",
    familyDeltaWorse: "Tu {make_model} obtiene {pts} puntos por debajo de la media de {family} ({n} coches analizados).",
    familyDeltaSame: "Tu {make_model} se sitúa justo en la media de la familia {family} ({n} coches analizados).",
    socialProofTitle: "Patrón en esta familia de motor",
    socialProofSubtitle: "De {n} {family} analizados:",
    socialProofIssueRow: "{pct}% tuvo {issue}",
    confidenceBadgeLabel: "Confianza",
    confidenceHigh: "ALTA",
    confidenceMedium: "MEDIA",
    confidenceLow: "BAJA",
    confidenceConsensus: "consenso de {n} IA",
    vinVerifiedLabel: "VIN verificado",
    vinVerifiedSource: "decodificado NHTSA",
    vinVerifiedTooltip: "Variante de motor, acabado y planta identificados desde tu VIN — análisis más preciso.",
    loadingFactPeers: "Comparación con {n} {family} ya analizados",
    loadingFactPeersFew: "Construyendo el perfil de esta familia de motor — menos de 5 vehículos de referencia",
    loadingFactMOT: "Leyendo {n} ITV registradas de este coche",
    loadingFactMOTNew: "Coche a estrenar — ninguna ITV registrada todavía",
    loadingFactAge: "{make} {model} ({year}) — cargando puntos débiles típicos",
    loadingFactScoring: "Cálculo del score Worthify — ninguna IA decide sola",
    loadingFactSafety: "Consultando resultados crash-test Euro NCAP",
    minimalRisk: "Riesgo mínimo",
    scoreLabel: "Worthify Score",
    accessFullAssessment: "Evaluación completa de riesgos",
    riskFactors: "Factores de riesgo",
    fullAnalysisInPdf: "Explicación completa de riesgos, consejos de negociación e historial MOT en el informe PDF",
    pdfUpsellTitle: "Obtener el informe de riesgo completo",
    pdfIncludes1: "Estimaciones específicas de costes de reparación",
    pdfIncludes2: "Ventaja de negociación (cantidades £)",
    pdfIncludes3: "Recomendación final comprar/evitar",
    pdfIncludes4: "Análisis detallado de riesgos",
    pdfIncludes5: "Información sobre motor y fiabilidad",
    topResultCta: "Obtener ayuda",
    topResultSupportCopy: "Sea cual sea el veredicto — estamos contigo. Cifras reales, argumentos reales, protección real.",
    unlockSectionHeadline: "No necesitas ser experto en coches para comprar uno bueno. Descarga el PDF con pautas y datos para bajar el precio de compra. Mira el análisis completo explicado de forma sencilla. No dejes que te engañen.",
    unlockSectionCta: "Desbloquear 🔓 / Descargar PDF / Datos avanzados por £1",
    resultVerdictLabel: "Veredicto",
    riskOutlookLabel: "Panorama de riesgo",
    potentialLossLabel: "Pérdida potencial",
    decisionMoodLabel: "Señal de decisión",
    heroCaptionHigh: "Este coche podría ser caro de mantener.",
    heroCaptionMedium: "Piénsalo dos veces antes de decir que sí.",
    heroCaptionLow: "Esta oferta parece más segura que la mayoría.",
    costAlertLabel: "Alerta de coste",
    vehicleSnapshotLabel: "Resumen del vehículo",
    priorityReviewLabel: "Riesgos prioritarios",
    unlockPremiumSection: "Desbloquear sección premium",
    fullIssuesEyebrow: "Todos los problemas",
    advancedDataLabel: "Datos avanzados",
    pdfUnlockLabel: "Desbloqueo PDF",
    aiSummaryTitle: "Resumen experto",
    aiAnalysisTitle: "Análisis de experto",
    riskExplanation: "Explicación del riesgo",
    positivesTitle: "Señales positivas",
    negotiationInsight: "Consejo de negociación",
    finalAdvice: "Consejo final",
    topRiskTitle: "Riesgo principal",
    otherRisksTitle: "Otros riesgos potenciales",
    otherRisksSubtitle: "Debilidades típicas de este motor / plataforma — no confirmadas en este coche.",
    repairCost: "Coste de reparacion",
    knownModelIssuesTitle: "Problemas conocidos del modelo",
    aiEstimatedValue: "Valor estimado",
    priceEvalTitle: "Evaluacion del precio",
    evidenceTitle: "Evidencia del MOT",
    expertNoteLabel: "Nota de experto",
    notConfirmedBadge: "No confirmado en este coche",
    engineFamilyContext: "Contexto motor / plataforma",
    consequencesTitle: "Si se ignora",
    severityHigh: "RIESGO ALTO",
    severityMedium: "RIESGO MEDIO",
    severityLow: "RIESGO BAJO",
    engineAnalysisTitle: "Analisis del motor",
    engineIdentified: "Motor identificado",
    engineCode: "Codigo del motor",
    engineKnownIssues: "Problemas conocidos del motor",
    typicalWeaknessesTitle: "Debilidades típicas de este motor",
    typicalWeaknessesDisclaimer: "Son problemas potenciales conocidos para ESTA familia de motores — pueden ocurrir, pero no necesariamente. Los defectos reales confirmados de tu coche están en el historial MOT debajo.",
    safetyRatingLabel: "Seguridad (crash test)",
    safetyVerdictSafe: "Alta seguridad — probada en crash tests",
    safetyVerdictAverage: "Seguridad media — adecuada pero no destacable",
    safetyVerdictPoor: "Seguridad por debajo de la media — considera alternativas",
    safetyRatingSource: "Prueba independiente Euro NCAP",
    engineConfidence: "Confianza",
    mileageAnalysisTitle: "Analisis de kilometraje",
    averageYearly: "Media anual",
    milesPerYear: "millas/ano",
    mileageTrend: "Tendencia",
    trendStable: "Estable",
    trendHigh: "Alto uso",
    trendLow: "Bajo uso",
    trendInconsistent: "Inconsistente",
    trendRollback: "Retroceso del odometro",
    trendUnknown: "Desconocido",
    mileageFlags: "Alertas",
    flagRollback: "Retroceso del odometro sospechado",
    flagLowUsage: "Uso muy bajo detectado",
    flagHighUsage: "Alto kilometraje anual",
    flagInconsistent: "Inconsistencia del kilometraje",
    aiMileageInsight: "Análisis experto del kilometraje",
    
    // Scam Detection
    scamWarning: "ALERTA DE PRECIO",
    scamAlertTitle: "Posible estafa detectada",
    scamAlertDesc: "Este precio es sospechosamente bajo. Podría indicar fraude, vehículo robado o daños ocultos.",
    scamRiskBadge: "ALTO RIESGO DE ESTAFA",
    suspiciousBadge: "PRECIO SOSPECHOSO",
    overpricedBadge: "SOBREVALORADO",
    fairPriceBadge: "PRECIO JUSTO",
    priceRange: "Rango del mercado",
    priceComparison: "Precio vs valor real",
    ofMarketValue: "del valor real",
    
    // Vehicle Information
    vehicleInfo: "Información del vehículo",
    mileageLabel: "Kilometraje",
    mileageVsAge: "millas/ano promedio para la edad del vehiculo",
    registration: "Matrícula",
    makeModel: "Marca y Modelo",
    year: "Año",
    engine: "Motor",
    engineCode: "Código de motor",
    
    // Statistics
    totalTests: "Tests totales",
    failedTests: "Tests fallidos",
    failsInLast3: "Fallos en los últimos 3",
    dangerousDefects: "Defectos peligrosos",
    recurringIssues: "Problemas recurrentes",
    
    // Analysis sections
    aiExpertAnalysis: "Análisis experto",
    priceAnalysis: "Análisis de precios",
    marketMedian: "Mediana del mercado",
    typicalRange: "Rango típico",
    priceFlag: "Indicador de precio",
    knownIssues: "Problemas conocidos de este modelo",
    anomaliesDetected: "Anomalías detectadas",
    recurringIssuesTitle: "Problemas recurrentes",
    motTestHistory: "Historial de pruebas MOT",
    detectedIssuesTitle: "Problemas detectados",
    fullIssuesTitle: "Problemas",
    
    // Defect types
    advisory: "Aviso",
    major: "Mayor",
    dangerous: "Peligroso",
    recurring: "Recurrente",
    
    // MOT Timeline
    noDefectsFound: "✓ Sin defectos encontrados - prueba limpia",
    miles: "millas",
    expires: "Expira",
    appears: "Aparece",
    times: "veces",
    
    // Anomaly descriptions
    mileageDrop: "Lectura del odómetro disminuyó entre pruebas - posible manipulación",
    coolingSystemFlags: "Problemas del sistema de refrigeración detectados en el historial MOT",
    chainIssueSuspected: "Posibles problemas de cadena de distribución (común en este motor)",
    
    // Sources
    sources: "Fuentes",
    link: "Enlace",

    // Loading overlay
    analyzingTitle: "Analizando historial del vehículo...",
    loadingStep1: "Verificando historial MOT...",
    loadingStep2: "Detectando problemas ocultos...",
    loadingStep3: "Analizando patrones de kilometraje...",
    loadingStep4: "Identificando riesgos del motor...",
    loadingStep5: "Estimando costes de reparación...",
    loadingStep6: "Verificando anomalías...",
    loadingIssuesDetected: "Problemas potenciales detectados...",
    loadingFinalizing: "Finalizando evaluación de riesgos...",
    aiWorking: "Expertos analizando...",
    aiDispatch: "Reuniendo expertos...",
    aiRoleEngine: "Experto motor",
    aiRolePlatform: "Experto plataforma",
    aiRoleRisk: "Experto riesgos",
    expertConfirmBadge: "Verificado por 3 expertos",
    expertConfirmTitle: "Equipo de expertos confirmó",
    expertConfirmSubtitle: "3 expertos independientes revisaron tu informe completo",
    expertConfirmFinalScore: "Puntuación final",
    premiumExpertOverlayBadge: "Análisis premium completado",
    premiumExpertOverlayTitle: "Los expertos revisaron los datos completos",
    premiumExpertOverlaySub: "Actualizando tu Worthify Score con los registros oficiales…",
    premiumExpertOverlayScore: "Puntuación actualizada",
    premiumExpertOverlayDone: "Toca cualquier parte para ver el informe",
    premiumExpertAnnaRisk: "Anna · Experta de riesgo",
    premiumExpertEngine: "Marcus · Experto de motor",
    premiumExpertPlatform: "Iris · Experta de plataforma",
    premiumFindingWriteOff: "encontró un registro de siniestro total",
    premiumFindingTheft: "encontró un registro de robo",
    premiumFindingMileage: "detectó una anomalía de kilometraje",
    premiumFindingFinance: "encontró financiación pendiente",
    expertConfirmVerdictRefined: "Veredicto refinado con consenso completo de expertos",
    // Auto-generated translations (Worthify i18n batch)
    abiGroupLabel: "Grupo ABI",
    accidentCheck1: "Defectos de chasis/estructurales en historial MOT",
    accidentCheck2: "Fallos de alineación de dirección y suspensión",
    accidentCheck3: "Notas de reparación importante de carrocería en distintos centros",
    accidentCheck4: "Contrastado con registros industriales de accidentes",
    accidentChecksTitle: "Lo que verificamos",
    accidentModalTitle: "Historial de accidentes",
    accidentRiskHigh: "Posible historial de daños",
    accidentRiskLow: "Sin indicadores de accidente",
    accidentScopeLabel: "Basado en comprobaciones estructurales MOT",
    addVinBadge: "Mejora gratuita",
    addVinBadgeLowConf: "Mejorar precisión",
    addVinChecking: "Verificando VIN…",
    addVinCopy: "Detecta coches clonados y estafas de intercambio de VIN en segundos. Comparamos tu VIN contra la marca y año de DVLA — instantáneo, gratuito, sin pago adicional.",
    addVinCopyLowConf: "Este es un modelo más nuevo/de nicho — los datos públicos de precio son escasos. Añadir el VIN nos permite precisar el acabado exacto, precio de catálogo del año-modelo y valor residual real.",
    addVinCta: "Añadir VIN ahora",
    addVinDone: "Hecho",
    addVinError: "Error al verificar VIN. Inténtalo de nuevo.",
    addVinModalCopy: "Introduce el VIN de 17 caracteres del vendedor (permiso de circulación V5C o placa del parabrisas). Lo verificaremos contra la marca y año de DVLA — si no coincide, tu puntuación se forzará a EVITAR.",
    addVinModalTitle: "Verificar VIN",
    addVinOkCopy: "Sin señal de clonación. Tu panel ahora muestra la insignia verificada.",
    addVinOkTitle: "VIN verificado — marca y año coinciden",
    addVinScamCopy: "La puntuación se ha forzado a EVITAR. Consulta el banner rojo en tu panel.",
    addVinScamTitle: "Discrepancia de VIN detectada — posible coche clonado",
    addVinSubmit: "Verificar VIN ahora",
    addVinTitle: "Verificar que el VIN coincide con la matrícula",
    addVinTitleLowConf: "Añade el VIN para una valoración más ajustada",
    addVinUndecodableCopy: "La base de datos pública de EE.UU. no lista este VIN. Común en modelos exclusivos de UK — no es una alerta por sí solo.",
    addVinUndecodableTitle: "VIN guardado — no se pudo decodificar públicamente",
    aiSuggested: "Sugerido por IA",
    allClear: "Todo despejado",
    allDetectedIssues: "Todos los problemas detectados",
    analyzingReassurance: "El análisis suele completarse en 30–60 segundos",
    annualCostLabel: "Total anual",
    anomaliesShort: "Anomalías",
    assumedMiles: "asumiendo 10k mi/año",
    averageSoldLabel: "Precio medio vendido",
    averageYearlyMileage: "Kilometraje medio anual",
    avgDaysLabel: "Días medios de venta",
    avgDaysOnMarket: "días medios en mercado",
    avgYearlyMiles: "Millas medias/año",
    basedOn30yoLabel: "Conductor de 30 años, 5 años sin reclamaciones",
    basedOnLastNSales: "Basado en las últimas 5 ventas comparables",
    benefitAccident: "Verificación de accidentes y siniestro total",
    benefitDepreciation: "Previsión de depreciación",
    benefitEngine: "Análisis de motor y problemas conocidos",
    benefitFinance: "Verificación de financiación pendiente",
    benefitNegotiation: "Tácticas de poder de negociación",
    benefitPdf: "Informe PDF imprimible completo",
    benefitSimilar: "Coches similares vendidos (últimos 5)",
    benefitUlez: "ULEZ + costes de mantenimiento a 5 años",
    betaDataBannerBody: "Este módulo actualmente usa estimaciones heurísticas basadas en el perfil del vehículo. La integración de datos reales se lanza en la próxima versión.",
    betaDataBannerTitle: "Datos beta — versión completa próximamente",
    brakesLabel: "Frenos",
    cancelLabel: "Cancelar",
    checkNewCarCta: "Consultar un coche nuevo",
    checkNewCarForOnePound: "Consultar coche nuevo por £1.00",
    close: "Cerrar",
    co2Label: "CO₂",
    confidenceLabelHigh: "Alta confianza",
    confidenceLabelLow: "Confianza baja",
    confidenceLabelMedium: "Confianza media",
    copyNegoError: "Error al copiar — inténtalo de nuevo",
    copyNegoRangeLabel: "Rango",
    copyNegoSourceLabel: "Fuente",
    copyNegoSuccess: "Argumentos copiados — pega en WhatsApp o SMS",
    copyNegoTitle: "Worthify – argumentos de negociación",
    copyNegoTotalLabel: "Objetivo total",
    copyNegotiationAria: "Copiar argumentos de negociación al portapapeles",
    copyNegotiationCta: "Copiar argumentos de negociación",
    copyPasteReadyLabel: "Copia · pega · envía",
    costBreakdownTitle: "Desglose",
    costDriversTitle: "Qué impulsa estos costes",
    costFuel: "Combustible",
    costInsurance: "Seguro",
    costService: "Servicio",
    costSubtitleShort: "Costes realistas que deberías planificar para los próximos 12–24 meses.",
    costTax: "Impuesto de circulación",
    costTierClean: "Parece limpio",
    costTierHigh: "Alto",
    costTierLow: "Bajo",
    costTierModerate: "Moderado",
    currentRegLabel: "Actual",
    currentValueLabel: "Valor actual",
    damageHistoryLabel: "Historial de daños",
    dangerousDefectsFound: "defectos peligrosos encontrados",
    dangerousDefectsHeadline: "Tienes defectos peligrosos",
    dashboardAiDisclaimer: "Esto no es una inspección mecánica. Realiza siempre tu propia revisión mecánica antes de comprar.",
    dataSourceDvla: "Fuente: DVLA VES",
    dataSourcesCopy: "DVLA, MOT, Seguros, Datos del mercado y más",
    dataSourcesTitle: "Verificamos más de 50 fuentes de datos",
    daysToSell: "días para vender",
    defectRecurringSuffix: "Recurrente en MOT — no arreglado, puede empeorar con el tiempo.",
    defectThemeBrakes: "Desgaste de componentes de freno",
    defectThemeCorrosion: "Corrosión / desgaste estructural",
    defectThemeElectrical: "Problema eléctrico / de carga",
    defectThemeEmissions: "Problema del sistema de emisiones",
    defectThemeExhaust: "Desgaste del sistema de escape",
    defectThemeLights: "Fallo en iluminación",
    defectThemeOilLeak: "Fuga de aceite del motor / sello goteando",
    defectThemeScreen: "Parabrisas / cristales",
    defectThemeSeatbelt: "Revisión de cinturón / retención",
    defectThemeSteering: "Desgaste de dirección / junta de suspensión",
    defectThemeSuspension: "Desgaste de componentes de suspensión",
    defectThemeTyres: "Desgaste / estado de neumáticos",
    defectThemeWipers: "Limpiaparabrisas / lavaparabrisas",
    depreciationModalTitle: "Previsión de depreciación",
    detectedTimesPrefix: "Detectado",
    detectedTimesSuffix: "veces en el historial MOT",
    downloadingPdf: "Descargando…",
    dvlaRecordLabel: "Registro DVLA",
    engineAnalysisShort: "Problemas del motor",
    engineCodeLabel: "Código de motor",
    errorRateLimit: "Has hecho demasiadas consultas en poco tiempo. Espera unos minutos e inténtalo de nuevo.",
    errorRateLimitPayment: "Demasiados intentos de pago. Espera unos minutos e inténtalo de nuevo.",
    estimatedCost: "Coste estimado",
    euroClassLabel: "Clase Euro",
    expectedCostBottomCaption: "Coste estimado durante los próximos 12–24 meses",
    expectedCostFallbackDrivers: "La exposición típica de 12–24 meses para este coche es de alrededor de £{cost}, impulsada principalmente por {drivers}.",
    expectedCostFallbackGeneric: "La exposición típica de 12–24 meses para este coche es de alrededor de £{cost} basándose en su antigüedad, kilometraje y problemas conocidos del modelo.",
    expectedCostFallbackRange: "Rango realista £{lo}–£{hi}; el mantenimiento preventivo ahora suele mantenerte cerca del extremo inferior.",
    expectedCostFallbackTopRisk: "La exposición típica de 12–24 meses para este coche es alrededor de £{cost}, siendo {issue} la principal preocupación.",
    expectedCostHeroTitle: "Coste futuro\\nesperado",
    expectedCostInsight: "Los costes son moderados, pero los problemas recurrentes aumentan la posibilidad de facturas de reparación más altas.",
    expectedCostModalTitle: "Coste futuro esperado",
    expectedCostShortLabel: "Coste esperado",
    expectedCostShortTitle: "Inversión futura esperada",
    expectedCostSubtitle: "Coste estimado durante los próximos 12–24 meses",
    expertDeepAnalysisTitle: "Hallazgos de cada experto",
    expertInsightLabel: "Perspectiva del experto",
    expertLeverageTitle: "Poder de negociación",
    expertNoFindings: "Este experto no ha señalado hallazgos específicos.",
    expertSummaryLabel: "Resumen",
    expertTipBody: "Inspecciona el vehículo antes de comprarlo y presupuesta la reparación.",
    expertTipLabel: "Consejo del experto",
    expertVerifiedBadge: "Verificado",
    expertViewLabel: "Vista del experto",
    expertiseLockedMore: "más en Premium",
    expertiseModalTitle: "Análisis de expertos",
    expertiseUnlockCta: "Desbloquear premium",
    expertsCountBadge: "3 expertos",
    failedMotsLabel: "MOTs fallidos",
    failedMotsTitle: "Pruebas MOT fallidas",
    failedOnce: "prueba fallida",
    failedPlural: "pruebas fallidas",
    failedTestDetails: "Detalles de la prueba fallida",
    financeClean: "Sin financiación pendiente",
    financeCleanCopy: "No se ha detectado ningún préstamo, leasing o acuerdo HP activo contra este vehículo. Puedes proceder con seguridad.",
    financeContextCopy: "Con una valoración alrededor de {value}, los coches con financiación pendiente están implicados en ~5% de las disputas de venta privada en el Reino Unido. Este vehículo está limpio.",
    financeContextTitle: "Contexto",
    financeFound: "Financiación pendiente",
    financeFoundCopy: "Este vehículo tiene financiación activa — no puede venderse legalmente hasta que se liquide. Aléjate hasta que el vendedor muestre prueba de liquidación.",
    financeModalTitle: "Financiación pendiente",
    financeStatusLabel: "Estado de financiación",
    flaggedAnomalies: "Anomalías señaladas",
    forecastTableTitle: "Previsión",
    fromCountryLabel: "País",
    fullPdfReport: "Informe PDF completo",
    fullTimeline: "Cronología completa",
    govUkDisclaimer: "Estimado según año y combustible. Confirma en gov.uk/check-clean-air-zone-charge",
    helpDownloadHero: "Descarga tu informe completo",
    helpDownloadSub: "Análisis Premium + PDF — ya pagado",
    helpHeroKicker: "3 expertos independientes",
    helpHeroTitle: "Evaluando el historial de este vehículo para ti",
    helpModalTitle: "Cómo funciona Worthify",
    helpSection1Copy: "La tarjeta principal muestra el veredicto basado en 3 expertos independientes que evalúan el historial de este vehículo.",
    helpSection1Title: "Tu veredicto",
    helpSection2Copy: "Toca cualquier ficha para abrir el modal completo con detalles, gráficos y consejos de expertos. Desliza izquierda/derecha para moverte entre modales.",
    helpSection2Title: "Explora cada ficha",
    helpSection3Copy: "Un único pago de £4.99 desbloquea análisis del motor, poder de negociación, comprobación de anomalías, riesgo de financiación oculta y el informe PDF imprimible completo.",
    helpSection3Title: "Desbloquea todo",
    helpUnlockHero: "Desbloquea la imagen completa",
    helpUnlockSub: "Motor · Negociación · Anomalías · Financiación · PDF",
    heroFailedLabel: "FALLIDO",
    heroHpiBadgeAria: "Descubre más sobre More Than HPI Check",
    heroHpiBadgeText: "More Than HPI Check",
    heroLine1: "Comprueba el riesgo real antes de comprar.",
    heroLine2: "Mira cuánto podría costarte y si vale la pena.",
    heroLine3: "",
    heroMotPlural: "MOTS",
    heroMotSingular: "MOT",
    highRiskLabel: "RIESGO ALTO",
    hpiIncludedAi: "Información de Compra con IA",
    hpiIncludedFinance: "Verificación de Financiación Pendiente",
    hpiIncludedIdentity: "Verificación de Identidad del Vehículo",
    hpiIncludedImport: "Estado de Importación / Exportación",
    hpiIncludedMarket: "Valoración de Mercado",
    hpiIncludedMileage: "Detección de Anomalías de Kilometraje",
    hpiIncludedMot: "Análisis de Historial MOT",
    hpiIncludedPdf: "Exportación de Informe PDF",
    hpiIncludedPlate: "Historial de Cambios de Matrícula",
    hpiIncludedRisk: "Evaluación de Riesgo del Vehículo",
    hpiIncludedShare: "Compartir con Mecánico",
    hpiIncludedStolen: "Verificación de Vehículo Robado",
    hpiIncludedVin: "Verificación VIN",
    hpiIncludedWorthifyValue: "Análisis Worthify Value",
    hpiIncludedWriteOff: "Siniestro Total de Seguro (A, B, S, N)",
    ifIgnoredTitle: "Si se ignora, puede provocar:",
    importDetected: "Importación detectada",
    importImpactCopy: "Los coches importados pueden ser más difíciles de asegurar y tener menor disponibilidad de piezas. Comprueba el V5C para la fecha de registro en Reino Unido y cualquier certificado NOVA (Notification of Vehicle Arrival).",
    importImpactTitle: "Qué significa esto",
    importModalTitle: "Historial de importación",
    importTypeLabel: "Tipo de importación",
    inLabel: "En",
    includedTitle: "Todo lo que incluye",
    independentBadge: "Independiente",
    insuranceDisclaimer: "Grupo estimado. Tu prima real depende de edad, código postal, historial de reclamaciones y franquicia.",
    insuranceGroupModalTitle: "Grupo de seguro",
    issuesFound: "problemas encontrados",
    knownIssuesTitle: "Problemas conocidos del motor",
    lastChangeLabel: "Último cambio",
    legalAllRights: "Todos los derechos reservados.",
    legalBackToHome: "Volver a Worthify",
    legalLastUpdated: "Última actualización",
    legalNavCookies: "Política de Cookies",
    legalNavAccessibility: "Accesibilidad",
    legalNavPrivacy: "Política de Privacidad",
    legalNavTerms: "Condiciones de Servicio",
    leverageLabel: "Ventaja",
    lifeRemaining: "vida útil restante",
    lockedPremiumCopy: "Desbloquea esta sección junto con el informe PDF completo y otras 14 verificaciones premium por £4.99.",
    lockedPremiumTitle: "Análisis premium",
    looksLike: "Parece",
    looksLikeA: "Parece un",
    lowRiskLabel: "RIESGO BAJO",
    marketGaugeAskingLabel: "Precio",
    marketGaugeMarketLabel: "Mercado",
    marketGaugeVsMarket: "vs mercado",
    marketGauge_FAIR: "Precio justo",
    marketGauge_SIGNIFICANTLY_OVER: "Muy sobrevalorado",
    marketGauge_SLIGHTLY_OVER: "Ligeramente sobrevalorado",
    marketGauge_UNDERPRICED: "Infravalorado",
    maybeLaterCta: "Quizás más tarde",
    mediumRiskLabel: "MEDIO",
    methodologyConfHighHint: "Historial MOT, VIN y kilometraje presentes — consenso multi-IA en los resultados.",
    methodologyConfLowHint: "Datos públicos limitados para este vehículo. La puntuación es heurística — se recomienda encarecidamente una inspección física.",
    methodologyConfMedHint: "Faltan algunos datos (p. ej. VIN o MOT completo). La puntuación es fiable pero no máxima.",
    methodologyConfidence: "Confianza: {level}",
    methodologyDisclaimer: "Worthify agrega datos oficiales de DVSA, DVLA y NHTSA con un motor de consenso de 3-IA — un verdadero More Than HPI Check a una fracción del precio. No sustituye una inspección física. Reserva siempre tu propia revisión mecánica antes de comprar.",
    methodologyDisclaimerTitle: "Inspección independiente aún recomendada",
    methodologyIntro: "Worthify combina datos públicos del gobierno británico con un consenso de IA de 3 modelos para estimar el riesgo de comprar un coche usado específico. Aquí está exactamente de dónde procede cada información.",
    methodologySourcesTitle: "Fuentes de datos",
    methodologyTitle: "Cómo funciona Worthify",
    mileageAnomalyBadge: "ANOMALÍA",
    mileageAnomalyCopy: "Anomalía de kilometraje detectada",
    mileageConsistent: "El kilometraje parece consistente",
    mileageHeroTitle: "Análisis de\\nkilometraje",
    mileageInsightAnomaly: "La progresión del kilometraje muestra inconsistencias. Revisa los registros de servicio cuidadosamente.",
    mileageInsightConsistent: "El kilometraje parece consistente con la antigüedad y el historial del vehículo.",
    mileageInsightTitle: "Información sobre kilometraje",
    mileageStableBadge: "ESTABLE",
    monthlyCostLabel: "Por mes",
    moreHpiEveryoneBody: "Diseñado para compradores cotidianos de coches, conductores novatos, familias, entusiastas y motoristas experimentados por igual. Ya seas mecánico o estés comprando tu primer coche, Worthify te ayuda a entender qué significan realmente los datos antes de gastar tu dinero.",
    moreHpiEveryoneTitle: "Creado para todos",
    moreHpiFooterChips: "🛡 More Than HPI Check · Análisis IA · Valoración de Mercado · Información Premium",
    moreHpiFooterTagline: "Inteligencia Vehicular, No Solo Historial Vehicular.",
    moreHpiFooterTrust: "Impulsado por inteligencia vehicular fiable del Reino Unido y fuentes de datos oficiales de vehículos.",
    moreHpiHeaderSub: "La plataforma de inteligencia vehicular más avanzada del Reino Unido, creada para ayudarte a tomar la decisión correcta antes de comprar.",
    moreHpiHeaderTitle: "Por Qué Worthify Es Diferente",
    moreHpiHeroBody: "Combinamos datos fiables del Reino Unido, valoración de mercado y análisis IA para darte respuestas claras, explicaciones sencillas y confianza real.",
    moreHpiHeroHighlight: "More Than HPI Check",
    moreHpiHeroPost: ".",
    moreHpiHeroPre: "Worthify es ",
    moreHpiIncludedTitle: "Inteligencia Vehicular Premium Incluida",
    moreHpiIntroBody: "More Than HPI Check — Worthify combina inteligencia vehicular fiable del Reino Unido, valoración de mercado y análisis impulsado por IA en un informe fácil de entender.",
    moreHpiIntroLead: "Worthify no solo muestra datos del vehículo — los explica.",
    moreHpiModalSubtitle: "La Mejor Relación Calidad-Precio en Plataforma de Inteligencia Vehicular del Reino Unido",
    moreHpiModalTitle: "¿Por Qué Es Diferente Worthify?",
    moreHpiMultilingualBody: "Los informes y explicaciones de vehículos están disponibles en varios idiomas, haciendo las revisiones de vehículos más accesibles para todos en el Reino Unido.",
    moreHpiMultilingualTitle: "Soporte multilingüe",
    moreHpiNoKnowBody: "Worthify traduce datos complejos de vehículos en explicaciones sencillas que cualquiera puede entender. Comprende qué significan los datos antes de gastar tu dinero.",
    moreHpiNoKnowTitle: "No se requiere conocimiento automotriz",
    moreHpiSourcesLine: "Utilizamos fuentes de datos fiables del Reino Unido incluyendo DVLA, DVSA y proveedores líderes de datos vehiculares.",
    moreHpiValueBody: "Worthify ofrece inteligencia vehicular avanzada, valoración de mercado, análisis MOT e información de compra impulsada por IA por solo ",
    moreHpiValueBodyEnd: ".",
    moreHpiValueKicker: "¿Por qué pagar £30+?",
    moreHpiWhy30Body: "Worthify combina inteligencia vehicular avanzada, valoración de mercado y análisis impulsado por IA en un informe asequible. Sin jerga. Solo respuestas claras en las que puedes confiar.",
    moreHpiWhy30Title: "¿Por qué pagar £30+ por un informe vehicular tradicional?",
    moreLockedHeadline: "3 análisis premium bloqueados",
    motConfirmedBadge: "Confirmado-MOT",
    motExpiryLabel: "MOT vence",
    motHistoryLabel: "Historial MOT",
    motHistoryTitle: "Historial MOT",
    navExpertise: "Experiencia",
    navMore: "Más",
    navOverview: "Resumen",
    navPremium: "Premium",
    navReports: "Informes",
    navSearch: "Nueva Búsqueda",
    navVehicle: "Vehículo",
    negoAskingLabel: "Precio solicitado",
    negoBulletComfortPrice: "Una oferta cómoda que refleja este riesgo se sitúa cerca de £{price}.",
    negoBulletKnownIssues: "Este modelo tiene {n} puntos débiles documentados — menciónalos en la visita.",
    negoBulletTopRisk: "Riesgo principal: {issue} — la reparación típicamente cuesta £{lo}–£{hi}.",
    negoBulletTotalExposure: "Exposición total de reparación: £{lo}–£{hi} en los próximos 24 meses.",
    negoEmptyCopy: "No se detectaron puntos de negociación significativos — el perfil técnico y de mercado de este coche se ve limpio. Una oferta firme pero justa al precio solicitado (o 2–3% por debajo) es razonable.",
    negoFairWithRepairsLabel: "Justo con reparaciones",
    negoMarketValueLabel: "Valor de mercado",
    negoScamBullet1: "Verifica la identidad del vendedor en persona antes de cualquier pago",
    negoScamBullet2: "Realiza una revisión DVLA / de historial completo sobre el VIN antes de transferir fondos",
    negoScamBullet3: "Rechaza cualquier solicitud de cripto / tarjeta regalo / transferencia bancaria",
    negoScamCopy: "El precio solicitado (£{asking}) está muy por debajo del valor real de mercado de este coche (£{value}). Este patrón casi siempre indica un anuncio falso, vehículo robado, daños no declarados o estafa de depósito en garantía. No pagues ningún depósito, no compartas documentos ni organices transporte. Denuncia el anuncio y sigue adelante.",
    negoScamHeader: "Estafa detectada",
    negoScamTitle: "No negocies — aléjate",
    negoScamVinCopy: "El VIN del vendedor decodifica como {vinMake} {vinYear}, pero el registro de DVLA muestra {dvlaMake} {dvlaYear}. Esta es una señal clásica de coche clonado / intercambio de VIN. No pagues ningún depósito ni compartas documentos.",
    negoScamVinTitle: "El VIN no coincide con el registro — aléjate",
    negoSuspiciousAsk1: "¿Por qué está el precio por debajo del mercado? (¿pérdida de empleo / venta rápida / problema oculto?)",
    negoSuspiciousAsk2: "Solicita una comprobación de historial completo + documento V5C + historial de servicio completo antes de cualquier depósito",
    negoSuspiciousAsk3: "Inspecciona en persona — nunca pagues mediante cripto / transferencia / tarjeta regalo",
    negoSuspiciousCopy: "Solicitar £{asking} ya está £{gap} por debajo del valor de mercado de este coche (£{market}). Incluso después de las £{rLo}–£{rHi} en reparaciones probables, un precio justo se sitúa alrededor de £{fair}. El vendedor lo ofrece por menos. Averigua por qué antes de pagar nada.",
    negoSuspiciousKicker: "Precio solicitado ya por debajo del mercado",
    negoSuspiciousTitle: "No negocies a la baja — verifica primero",
    negotiationCumulativeLabel: "Ahorro acumulado del comprador",
    negotiationHeadline: "Objetivo de negociación",
    negotiationItemTarget: "Oferta sugerida",
    negotiationShort: "Palanca",
    newSearchCopy: "Inicia un nuevo análisis para otra matrícula. El análisis actual permanecerá guardado.",
    newSearchPaymentCopy: "Cada comprobación de vehículo es un pago único de £1 que desbloquea todos los análisis premium para ese coche.",
    newSearchPaymentTitle: "Un nuevo análisis requiere un nuevo pago",
    newSearchTitle: "Nueva comprobación de coche",
    noAnomalies: "No se detectaron anomalías en el historial MOT.",
    noFailedDetails: "Datos detallados de fallos no disponibles para este vehículo.",
    noImportFlag: "Mercado UK / UE",
    noMajorRisks: "Sin riesgos importantes",
    noMotDetails: "Cronología detallada de MOT no disponible.",
    noPriceEvalCopy: "Añade un precio objetivo para obtener una comprobación de precio.",
    noRecurring: "No se encontraron problemas recurrentes en el historial MOT.",
    noVinForImport: "Añade un VIN en la página de inicio para una comprobación completa de país de origen.",
    nowLabel: "Ahora",
    offAskingLabel: "menos del precio solicitado",
    originLabel: "Origen",
    ourVerdictLabel: "Nuestro veredicto",
    outOfLabel: "de",
    ownerLabel: "Propietario",
    ownerPlural: "propietarios registrados",
    ownerSingular: "propietario registrado",
    ownersAverageCopy: "Propiedad promedio — sin señales de alarma, pero solicita registros de servicio.",
    ownersCountLabel: "Total de propietarios",
    ownersFewCopy: "Pocos propietarios — generalmente significa que el coche fue bien cuidado.",
    ownersInsightTitle: "Información de propiedad",
    ownersManyCopy: "Muchos propietarios en poco tiempo puede indicar problemas — investiga cuidadosamente.",
    ownersModalTitle: "Propietarios anteriores",
    ownersTimelineTitle: "Cronología de propiedad",
    ownersV5CFreshNote: "Emitido en los últimos 12 meses — normalmente indica un cambio reciente de propiedad (DVLA).",
    ownersV5CLabel: "Último V5C emitido",
    ownersV5COldNote: "El mismo documento V5C sigue activo — sin transferencia registrada reciente.",
    paymentCancelledBody: "No se ha realizado ningún cargo. Puedes intentarlo de nuevo cuando estés listo.",
    paymentCancelledTitle: "Pago cancelado",
    paymentTimeoutError: "El pago está tardando más de lo habitual. Si te han cobrado, contacta con support@worthify.co.uk indicando el ID de sesión: ",
    pdfDownloadCopy: "Tu informe PDF completo está listo.",
    pdfDownloadNow: "Descargar informe completo",
    pdfDownloadTitle: "Descarga tu informe completo",
    pdfFullReportLabel: "Informe Completo",
    pdfIncludesTitle: "Qué incluye",
    pdfReportLabel: "Informe PDF completo",
    pdfReportValue: "Descargar",
    pdfUnlockCopy: "Obtén el desglose completo, análisis experto y análisis de costes en PDF.",
    pdfUnlockCta: "Desbloquear por £4.99",
    pdfUnlockTitle: "Desbloquea el informe completo",
    pdfUnlockedLabel: "Desbloqueado",
    perMonth: "al mes",
    perYear: "por año",
    perYearLabel: "por año",
    policeRegisterLabel: "Registro policial",
    preCheckoutBadge: "Confirmar compra",
    preCheckoutBenefitMot: "Análisis de riesgo MOT",
    preCheckoutBenefitRecall: "Verificación de recall + siniestro total",
    preCheckoutBenefitShare: "PDF + compartir con mecánico",
    preCheckoutBenefitValuation: "Valoración de mercado",
    preCheckoutConsent: "Acepto la entrega instantánea y entiendo que pierdo mi derecho de desistimiento de 14 días.",
    preCheckoutNoSub: "Sin suscripción · Sin renovación automática",
    preCheckoutOneTime: "Pago único",
    preCheckoutPayCta: "Pagar £{n} con Stripe",
    preCheckoutPdfProductName: "Informe Worthify Premium (PDF + 15 módulos)",
    preCheckoutRedirecting: "Redirigiendo a Stripe…",
    preCheckoutTickToContinue: "Marca la casilla para continuar",
    preCheckoutTotal: "Total",
    preCheckoutTrustLine: "Seguro con Stripe · Los datos de tu tarjeta nunca tocan Worthify · Recibo enviado automáticamente",
    preCheckoutVerdictProductName: "Veredicto Básico Worthify",
    preCheckoutWarningBody: "Tu informe se entrega inmediatamente en tu navegador en cuanto el pago tenga éxito. Al confirmar, aceptas el inicio inmediato de la prestación y renuncias a tu derecho de desistimiento de 14 días según UK Consumer Contracts Regulations 2013.",
    preCheckoutWarningTitle: "Entrega digital instantánea",
    premiumAnalysesBadge: "Análisis premium",
    premiumAnalysesLocked: "análisis premium bloqueados",
    premiumAnalysesTitle: "Todos los análisis",
    premiumEstimateTitle: "Estimación de prima anual",
    premiumHomeCopy: "Toca cualquier mosaico para explorar el análisis completo. Toca Resumen para volver al panel principal.",
    premiumHomeFooter: "Toca Resumen abajo para volver al panel principal",
    premiumHomeKicker: "Premium · Desbloqueado",
    premiumHomeTitle: "Los 15 análisis premium",
    premiumLabel: "Premium",
    premiumLockedTag: "Premium · Bloqueado",
    premiumPositioningSub: "Financiación · Robado · Siniestro Total · VIN · Insights IA · Valoración de Mercado",
    premiumPositioningTagline: "More Than HPI Check",
    premiumRangeLabel: "Prima habitual",
    premiumUnlockedTag: "Premium · Desbloqueado",
    priceCheckLabel: "Verificación de precio",
    priceFair: "Precio justo",
    priceFairBig: "PRECIO JUSTO",
    priceNoData: "No se detectaron problemas de precio",
    priceOptionalHint: "Opcional · desbloquea verificación de precio",
    priceOverpriced: "Precio parece elevado",
    priceOverpricedBig: "SOBREPRECIO",
    priceScamTitle: "Comprobación de precio",
    priceSubtitleDetected: "Basado en datos de mercado e historial.",
    priceSuspicious: "Precio parece sospechoso",
    priceSuspiciousBig: "PRECIO SOSPECHOSO",
    pricingFooterLine1: "Comienza con una recomendación gratuita.",
    pricingFooterLine2: "Mejora sólo si quieres insights más profundos e inteligencia premium del vehículo.",
    pricingTransparencySub: "Tres niveles. Paga sólo por la profundidad que necesitas.",
    pricingTransparencyTitle: "Precio Simple. Transparencia Total.",
    proceedToPaymentCta: "Continuar al pago — £4.99",
    rangeLabel: "rango",
    realisticRangeLabel: "Rango realista",
    recentSalesTitle: "Ventas comparables recientes",
    recurringAcross: "durante",
    recurringIgnoredBadge: "Ignorado múltiples ciclos",
    recurringIssuesLabel: "Problemas Recurrentes",
    recurringIssuesTimelineTitle: "Cronología de problemas recurrentes",
    recurringYearsLabel: "años",
    regPlaceholder: "ej. AB12CDE",
    registrationLabel: "Matrícula",
    riskSuffix: "RIESGO",
    runningCostsDisclaimer: "Estimaciones basadas en promedios del Reino Unido. Los costes reales varían según el estilo de conducción, ubicación y aseguradora.",
    runningCostsModalTitle: "Costes de funcionamiento",
    safetyAxisAdult: "Ocupante adulto",
    safetyAxisAssist: "Asistencia de seguridad",
    safetyAxisChild: "Ocupante infantil",
    safetyAxisPedestrian: "Peatón / VRU",
    safetyBreakdownCopy: "Cómo puntúa este coche en las cuatro áreas de prueba de Euro NCAP.",
    safetyBreakdownTitle: "Desglose completo de seguridad",
    safetyBreakdownUnlockCta: "Desbloquear desglose completo — £4.99",
    safetyCardTitle: "Seguridad (Prueba de choque)",
    safetyCopy1: "Protección ante choques deficiente — 1★ Euro NCAP. Importantes problemas de seguridad en impactos reales; considera una alternativa más segura si es posible.",
    safetyCopy2: "Protección ante choques débil — 2★ Euro NCAP. Por debajo de los estándares modernos de seguridad, con riesgo medible en impactos frontales y laterales.",
    safetyCopy3: "Protección ante choques promedio — 3★ Euro NCAP. Aceptable para su época, pero los rivales más nuevos ofrecen seguridad notablemente mejor para ocupantes y peatones.",
    safetyCopy4: "Rendimiento sólido en pruebas de choque — 4★ Euro NCAP. Un paquete de seguridad bien construido que se mantiene bien en las pruebas de impacto modernas.",
    safetyCopy5: "Protección ante choques de primer nivel — 5★ completas Euro NCAP. Entre los coches más seguros de su época, con sólida protección para adultos, niños y peatones.",
    safetyGoodCopy: "Rendimiento sólido en pruebas de choque para su época.",
    safetyHeadline1: "Seguridad deficiente",
    safetyHeadline2: "Seguridad débil",
    safetyHeadline3: "Seguridad promedio",
    safetyHeadline4: "Seguridad sólida",
    safetyHeadline5: "Seguridad excelente",
    safetyNoDataCopy: "No hay valoración Euro NCAP disponible para este modelo.",
    safetyOkCopy: "Rendimiento promedio en pruebas de choque para su época.",
    safetyPoorCopy: "Rendimiento por debajo del promedio en pruebas de choque.",
    safetyTileAverage: "Seguridad promedio en pruebas de choque para su época",
    safetyTileNoData: "Sin datos de Euro NCAP",
    safetyTilePoor: "Protección ante choques por debajo del promedio",
    safetyTileStrong: "Seguridad sólida — probada en pruebas de choque",
    scamAllClearCopy: "El historial MOT y el kilometraje se ven consistentes.",
    scamAllClearTitle: "No se detectaron señales de alerta",
    scamCheck1: "Consistencia del kilometraje en las pruebas MOT",
    scamCheck2: "Historial de defectos peligrosos",
    scamCheck3: "Defectos recurrentes o ignorados",
    scamCheck4: "Lagunas largas en MOT o patrones sospechosos",
    scamChecklistTitle: "Qué revisamos",
    scamDetectionLabel: "Verificaciones de estafa",
    scamFlaggedBadge: "Marcado",
    scamSafeBadge: "Sin señales de alerta",
    scamSafeValue: "Limpio",
    scoreBadgeBad: "DEFICIENTE",
    scoreBadgeGood: "BUENO",
    scoreBadgeOk: "PROMEDIO",
    scoreDisclaimer: "Las puntuaciones se basan en datos disponibles y no garantizan el estado del vehículo.",
    scoreExpertsUnlockCta: "Desbloquear análisis experto completo — £4.99",
    scoreScaleAverage: "Promedio",
    scoreScaleExcellent: "Excelente",
    scoreScaleGood: "Bueno",
    scoreScalePoor: "Deficiente",
    scoreScaleTitle: "Escala de puntuación",
    scoreScaleVeryPoor: "Muy deficiente",
    scoreScamHeader: "Estafa detectada",
    scoreScamPriceCopy: "El precio solicitado está muy por debajo del valor real de mercado de este coche. Casi siempre indica un anuncio falso, vehículo robado o estafa de depósito en garantía — puntuación forzada a 25/100 (EVITAR).",
    scoreScamPriceTitle: "Precio solicitado muy por debajo del valor real de mercado",
    scoreScamVinCopy: "El VIN del vendedor decodifica a una marca o año diferente que el registro de DVLA. Este patrón indica un coche clonado o estafa de intercambio de VIN — puntuación forzada a 25/100 (EVITAR).",
    scoreScamVinTitle: "El VIN no coincide con el registro",
    scoreShortBad: "Perfil de alto riesgo — planifica una inspección cuidadosa antes de comprometerte.",
    scoreShortGood: "Historial sólido — los números respaldan una compra con confianza.",
    scoreShortOk: "Señales mixtas — viable con negociación, pero vigila los problemas recurrentes.",
    seeFullExpertAnalysis: "Ver análisis experto completo",
    seenIn: "Visto en",
    seenInMotPrefix: "Confirmado por MOT",
    sellerScriptTitle: "Qué decir al vendedor",
    severityAdvisory: "Aviso",
    severityDangerous: "Peligroso",
    severityFailure: "Fallo",
    severityMajor: "Mayor",
    severityMinor: "Menor",
    severityNote: "Nota",
    shareReportCopied: "Enlace copiado",
    shareReportCopyManual: "Copia este enlace:",
    shareReportMessage: "Mira este informe de vehículo de Worthify",
    shareWithMechanicBadge: "Segunda opinión",
    shareWithMechanicCopied: "Enlace copiado — pégalo a tu mecánico",
    shareWithMechanicCopy: "Envía la matrícula a un mecánico o amigo de confianza. Recibirán un enlace para verificar los hallazgos antes de que te comprometas.",
    shareWithMechanicCopyError: "No se pudo copiar. Mantén presionado para compartir manualmente.",
    shareWithMechanicCta: "Compartir enlace",
    shareWithMechanicKicker: "¿Segunda opinión? Envía este informe a un mecánico de confianza.",
    shareWithMechanicMessage: "Hola — ¿qué opinas de este coche? Worthify lo analizó para mí:",
    shareWithMechanicTitle: "Comparte este informe con tu mecánico",
    similarSoldDisclaimer: "Precios muestreados de anuncios del Reino Unido para la misma marca/modelo y rango de años.",
    similarSoldModalTitle: "Coches vendidos similares",
    simpleExplanationCardSub: "Una respuesta de 60 segundos que cualquiera puede entender",
    simpleExplanationCardTitle: "¿Debería comprarlo?",
    simpleExplanationDisclaimer: "Este resumen es solo orientativo — siempre haz que un mecánico cualificado inspeccione el coche en persona antes de comprar.",
    simpleExplanationEmpty: "El análisis aún se está preparando. Inténtalo de nuevo en un momento.",
    simpleExplanationHeadline: "¿Debería comprarlo?",
    simpleExplanationKicker: "Lenguaje claro",
    simpleExplanationLockedBadge: "Bloqueado — desbloquea con Premium",
    simpleExplanationLockedTitle: "Desglose completo",
    simpleExplanationSubhead: "Una respuesta sin jerga basada en el análisis completo de Worthify — escrita para que cualquiera pueda entenderla.",
    simpleExplanationTitle: "Resumen en lenguaje claro",
    simpleExplanationUnlockCta: "Desbloquear explicación completa — Premium",
    simpleExplanationVerdictTitle: "Aquí está el tema",
    socialProofCopy: "Usado por más de 50.000 compradores de coches del Reino Unido",
    sourceAiDesc: "Tres modelos de lenguaje independientes analizan los datos en paralelo. El Worthify Score usa la mediana de sus estimaciones para que una sola alucinación no distorsione el resultado.",
    sourceDvsaDesc: "Gobierno oficial del Reino Unido — cada resultado de prueba MOT, avisos y defectos peligrosos.",
    sourceNhtsaDesc: "Base de datos pública del gobierno de EE.UU. usada para decodificar el VIN del vendedor y detectar estafas de coches clonados.",
    structuralFlagsLabel: "Indicadores estructurales",
    suggestedReductionKicker: "Reducción sugerida",
    suspiciousPriceCtaHint: "Toca para ver por qué importa esto →",
    suspiciousPriceKicker: "Precio de venta sospechosamente bajo",
    suspiciousPriceShort: "Pedir £{asking} es solo el {pct}% del valor de mercado (£{market}). Verifica antes de pagar nada.",
    swipeDownHint: "Consejo: desliza hacia abajo para cerrar",
    testRecorded: "prueba registrada",
    testedIn: "Probado en",
    testsRecorded: "pruebas registradas",
    theftCheck1: "Police National Computer (PNC)",
    theftCheck2: "Registro de robados DVLA",
    theftCheck3: "MIAFTR (industria de seguros)",
    theftCheck4: "Puertos / señales de importación",
    theftChecksTitle: "Registros verificados",
    theftClean: "Sin registro de robo",
    theftCleanCopy: "No se encontró ninguna entrada en el Police National Computer ni en el registro de robados de DVLA. Este vehículo parece legítimo.",
    theftFlagged: "Reportado como robado",
    theftFlaggedCopy: "Este vehículo está registrado como robado. NO continúes — contacta a la policía en el 101.",
    theftModalTitle: "Verificación de robo y robados",
    tierBestValue: "MEJOR VALOR",
    tierFreeBasicInfo: "Información Básica del Vehículo (Marca · Modelo · Año)",
    tierFreeBuyRec: "Recomendación de Compra",
    tierFreeCallout: "Perfecto para saber si este coche merece investigarse más a fondo.",
    tierFreeF1: "Recomendación de Compra Worthify (Evitar · Precaución · Buena Oferta)",
    tierFreeFooter: "Sepa si el vehículo merece una mirada más detallada.",
    tierFreeFooterQ: "¿Debería siquiera considerar este coche?",
    tierFreeIntro: "Obtenga una recomendación instantánea antes de gastar un céntimo.",
    tierFreeIntro2: "Obtenga una recomendación rápida antes de gastar un céntimo.",
    tierFreeLabel: "COMPROBACIÓN GRATUITA",
    tierFreeMot: "Estado MOT (Pass / Fail / Active)",
    tierFreeName: "Ayuda de Decisión Instantánea",
    tierFreeTax: "Estado del Impuesto",
    tierNewPill: "NUEVO",
    tierPremAiAdv: "Perspectivas de Compra IA (Avanzadas)",
    tierPremEverythingStd: "Todo lo de la Comprobación Estándar",
    tierPremF1: "Comprobaciones de Financiación Pendiente",
    tierPremF10: "Análisis de Valor Worthify (conjunto de datos premium)",
    tierPremF11: "Perspectivas de Compra con IA (modelo premium)",
    tierPremF12: "Informe PDF Premium (descargable)",
    tierPremF2: "Comprobaciones de Vehículo Robado",
    tierPremF3: "Categorías de Siniestro Total (A, B, S, N)",
    tierPremF4: "Verificación VIN (profunda)",
    tierPremF5: "Verificación de Identidad del Vehículo",
    tierPremF6: "Detección de Anomalías de Kilometraje",
    tierPremF7: "Evaluación de Riesgo del Vehículo",
    tierPremF8: "Historial de Cambios de Matrícula",
    tierPremF9: "Estado de Importación / Exportación",
    tierPremFinance: "Comprobación de Financiación Pendiente",
    tierPremIdentity: "Comprobación de Identidad del Vehículo",
    tierPremImport: "Comprobación de Importación / Exportación",
    tierPremMarket: "Valoración de Mercado",
    tierPremMileage: "Detección de Anomalías de Kilometraje",
    tierPremMotHistory: "Historial MOT Detallado",
    tierPremMulti: "Soporte Multiidioma",
    tierPremNego: "Ventaja de Negociación",
    tierPremPdf: "Descarga de Informe PDF",
    tierPremPlate: "Historial de Cambios de Matrícula",
    tierPremRiskAdv: "Evaluación de Riesgo (Avanzada)",
    tierPremShare: "Compartir Con Mecánico",
    tierPremStolen: "Comprobación de Vehículo Robado",
    tierPremVin: "Verificación VIN",
    tierPremWorthifyValue: "Valor Worthify (Datos Premium)",
    tierPremWriteOff: "Comprobación de Siniestro Total",
    tierPremiumBadge: "Mejor valor",
    tierPremiumCallout: "Todo lo que necesita antes de gastar miles en un vehículo.",
    tierPremiumFooter: "Todo lo que necesita antes de gastar miles en un vehículo.",
    tierPremiumFooterQ: "¿Qué riesgos debo conocer antes de comprar?",
    tierPremiumIncludes: "Todo lo de Estándar, más inteligencia vehicular avanzada:",
    tierPremiumIntro: "More Than HPI Check.",
    tierPremiumIntro2: "Obtenga inteligencia completa del vehículo, valor de mercado y análisis de riesgo.",
    tierPremiumLabel: "COMPROBACIÓN PREMIUM",
    tierPremiumName: "More Than HPI Check",
    tierStandardCallout: "Comprenda por qué esto podría ser una buena compra o arriesgada.",
    tierStandardFooter: "Comprenda qué significan realmente los datos del vehículo.",
    tierStandardFooterQ: "¿Por qué es esta una buena o mala compra?",
    tierStandardIntro: "Desbloquee el Análisis Completo Worthify.",
    tierStandardIntro2: "Desbloquee el análisis completo Worthify y comprenda los riesgos.",
    tierStandardLabel: "COMPROBACIÓN ESTÁNDAR",
    tierStandardName: "Comprenda la Decisión",
    tierStdAiExpl: "Análisis IA y Explicaciones",
    tierStdEverythingFree: "Todo lo de la Comprobación Gratuita",
    tierStdF1: "Worthify Buy Score Completo (0–100)",
    tierStdF10: "Valoración de Mercado Worthify",
    tierStdF2: "Análisis Consensuado Mejorado de 3 IAs",
    tierStdF3: "Análisis Detallado de MOT y Patrones de Fallo",
    tierStdF4: "Fortalezas y Debilidades del Vehículo",
    tierStdF5: "Análisis del Motor y Problemas Agrupados",
    tierStdF6: "Opiniones de Expertos (Mecánico · Concesionario · Economista)",
    tierStdF7: "Ventaja de Negociación y Estimaciones de Reparación",
    tierStdF8: "Análisis de Prueba de Choque / Seguridad",
    tierStdF9: "Compartir Con Mecánico",
    tierStdInitialRisk: "Evaluación Inicial de Riesgo",
    tierStdMot: "Análisis Detallado de MOT",
    tierStdScore: "Worthify Buy Score (0–100)",
    tierStdStrengths: "Fortalezas y Debilidades del Vehículo",
    topIssueLabel: "Problema principal en este coche",
    topIssueLead: "Este defecto fue registrado en el historial MOT de este vehículo.",
    topIssueLeadRecurring: "Este defecto ha aparecido en {count} pruebas MOT y sigue registrado — no se ha resuelto y es muy probable que empeore.",
    topRiskLabel: "Riesgo Principal",
    totalMilesLabel: "Millas totales",
    totalRangeLabel: "Rango completo",
    trustAisAgreed: "IAs coincidieron",
    trustDaysAgo: "hace {n} día",
    trustGdpr: "Cumple con GDPR",
    trustHoursAgo: "hace {n} h",
    trustHowItWorks: "Cómo funciona",
    trustIconAi: "Evaluación de riesgo con IA en la que puedes confiar",
    trustIconData: "Datos fiables de fuentes oficiales del Reino Unido",
    trustIconExplain: "Explicaciones sencillas para todos",
    trustIconOne: "Un informe. Todo lo que necesitas.",
    trustIconUk: "Diseñado para compradores del Reino Unido y vehículos del Reino Unido",
    trustInstant: "Acceso instantáneo",
    trustJustNow: "ahora mismo",
    trustMinutesAgo: "hace {n} min",
    trustSecure: "Seguridad Stripe",
    trustVerifiedBy: "Verificado por",
    typeLabel: "Tipo",
    tyreBrakeModalTitle: "Desgaste de neumáticos y frenos",
    tyresLabel: "Neumáticos",
    ulezChargesTitle: "Cargo diario en zonas del Reino Unido",
    ulezCompliantShort: "Cumple",
    ulezCompliantTitle: "Cumple con ULEZ",
    ulezModalTitle: "ULEZ / Aire Limpio",
    ulezNonCompliantShort: "Con cargo",
    ulezNonCompliantTitle: "No cumple con ULEZ",
    ulezStatusLabel: "Estado ULEZ",
    ulezUnknownNote: "DVLA no ha devuelto la clase de emisiones Euro para esta matrícula. Los diésel antiguos pueden adaptarse, y las matrículas personalizadas pueden ocultar un vehículo Euro 6 más nuevo — verifica con el comprobador oficial de TfL a continuación.",
    ulezUnknownTitle: "Estado ULEZ no confirmado",
    ulezVerifyOnTfl: "Verificar en TfL — comprobador oficial",
    ulezVerifyShort: "Verificar en TfL",
    unknownCause: "fallo mayor",
    unlockItemAccident: "Verificación de historial de accidentes",
    unlockItemAnomalies: "Anomalías y señales de diagnóstico",
    unlockItemCo2: "Emisiones de CO₂ y puntuación Eco",
    unlockItemCrashTest: "Prueba de choque y clasificación de seguridad",
    unlockItemDepreciation: "Previsión de depreciación",
    unlockItemEngineAnalysis: "Análisis del motor",
    unlockItemEngineExpert: "Veredicto del Experto en Motores",
    unlockItemFailedMots: "Desglose de MOT fallidos",
    unlockItemFinance: "Verificación de financiación pendiente",
    unlockItemImport: "Historial de importación y exportación",
    unlockItemInsurance: "Grupo de seguro",
    unlockItemMotHistory: "Historial MOT detallado y defectos",
    unlockItemNegotiation: "Evidencia de negociación (con objetivos en £)",
    unlockItemOwners: "Propietarios anteriores e historial V5C",
    unlockItemPdf: "Informe PDF descargable",
    unlockItemPlatformExpert: "Veredicto del Experto en Plataforma",
    unlockItemPriceCheck: "Detección de estafas y sobreprecio",
    unlockItemRecurring: "Detección de problemas recurrentes",
    unlockItemRiskExpert: "Veredicto del Experto en Riesgos",
    unlockItemRunningCosts: "Previsión de costes operativos a 5 años",
    unlockItemScore: "Worthify Score con desglose completo",
    unlockItemSimilarSold: "Vehículos similares vendidos",
    unlockItemSimpleExplanation: "Resumen comprar/evitar en lenguaje claro",
    unlockItemTaxMot: "Estado en vivo de DVLA tax y MOT",
    unlockItemTheft: "Verificación de robo y vehículo robado",
    unlockItemTopRisk: "Resumen de riesgo principal",
    unlockItemTyresBrakes: "Análisis de desgaste de neumáticos y frenos",
    unlockItemUlez: "Veredicto de cargos diarios ULEZ y CAZ",
    unlockItemVin: "Verificación cruzada VIN ↔ DVLA (detección de clones)",
    unlockItemWriteOff: "Verificación de siniestro total y seguro",
    unlockMoreDataCopy: "Pago único de £4.99 desbloquea motor, negociación, anomalías, propietarios, accidente, financiación, ULEZ, costes operativos, depreciación y 6 verificaciones más + PDF completo.",
    unlockMoreDataLabel: "Desbloquear más datos",
    unlockMoreDataTitle: "Desbloquea 15 análisis premium",
    useThisToNegotiate: "Usa esto para negociar",
    v5cIssuedLabel: "Último V5C",
    valueIn3Label: "Valor en 3 años",
    valueIn5Label: "Valor en 5 años",
    vehicleCo2Label: "Emisiones de CO₂",
    vehicleColourLabel: "Color",
    vehicleEngineLabel: "Motor",
    vehicleEuroLabel: "Clase Euro",
    vehicleFuelLabel: "Combustible",
    vehicleInformationTitle: "Información del vehículo",
    vehicleMakeLabel: "Marca",
    vehicleMarkedForExportLabel: "Marcado para exportación",
    vehicleMileageLabel: "Kilometraje",
    vehicleModelLabel: "Modelo",
    vehicleRegDateLabel: "Primer registro",
    vehicleSpecsTitle: "Especificaciones",
    vehicleTypeApprovalLabel: "Homologación",
    vehicleUlezLabel: "ULEZ",
    vehicleV5CLabel: "Último V5C",
    vehicleYearLabel: "Año",
    verdictMainMedium: "PRECAUCIÓN",
    verdictOverpricedSub: "El precio solicitado {subj} es el {pct}% del valor de mercado {median} — muy por encima del precio justo.",
    verdictOverpricedTitle: "Sobreprecio vs mercado",
    verdictPrefixHigh: "Mejor",
    verdictPrefixLow: "Parece una",
    verdictPrefixMedium: "Proceder con",
    verdictScamSub: "El precio solicitado {subj} es solo el {pct}% del valor de mercado {median} — perfil típico de estafa.",
    verdictScamTitle: "Precio de estafa detectado",
    verdictShortAvoid: "EVITAR",
    verdictShortBeCautious: "SER CAUTELOSO",
    verdictShortGoodDeal: "BUENA OFERTA",
    verdictSuspiciousSub: "El precio solicitado {subj} es solo el {pct}% del valor de mercado {median} — sospechosamente bajo.",
    verdictSuspiciousTitle: "Precio sospechosamente bajo",
    verifiedBy3Experts: "Verificado por 3 expertos independientes",
    viewAnomalies: "Ver anomalías",
    viewEngine: "Ver motor",
    viewFailedTests: "Ver pruebas falladas",
    viewHistory: "Ver historial",
    viewIssues: "Ver problemas",
    viewNegotiation: "Negociar",
    vinInvalidChars: "El VIN solo puede contener letras y números",
    vinInvalidLength: "El VIN debe tener exactamente 17 caracteres",
    vinOptionalHint: "Opcional · 17 caracteres · mejora la precisión",
    vinUndecodableNote: "Tu VIN ha sido registrado pero no pudo ser decodificado por la base de datos pública de EE.UU. Muchos modelos exclusivos del Reino Unido no aparecen allí — esto no es una señal de alarma por sí solo.",
    vinVerifiedBadge: "VIN verificado",
    vinVerifiedCopy: "El VIN del vendedor coincide con la marca y el año de DVLA. No se detectó señal de clonación.",
    wearBothCopy: "El historial MOT muestra defectos repetidos en neumáticos Y frenos. Presupuesta £600+ para reemplazo en los primeros 6 meses.",
    wearBrakeCopy: "El historial MOT señala desgaste en frenos. Presupuesta £200-400 para reemplazo de pastillas/discos.",
    wearTyreCopy: "El historial MOT señala desgaste en neumáticos. Presupuesta £300-500 para un juego de 4 neumáticos.",
    wearWarningTitle: "Presupuesta para reemplazo",
    whatThisMeans: "Qué significa esto",
    whatYouGetHeadline: "15 análisis premium + PDF completo",
    whatYouGetKicker: "Desbloqueo premium — £4.99",
    whatYouGetTitle: "Qué obtendrás",
    whyRiskTitle: "¿Por qué es un riesgo?",
    whyThisScore: "¿Por qué esta puntuación?",
    worthifyExpertName: "Worthify Expert",
    worthifyExpertRole: "Especialista en historial de vehículos · Consenso de 3 IA",
    worthifyScoreLabel: "Worthify Score",
    writeOffCatA: "Solo chatarra",
    writeOffCatB: "Despiece para repuestos",
    writeOffCatN: "No estructural",
    writeOffCatS: "Daño estructural",
    writeOffCategoriesTitle: "Verificación de categoría",
    writeOffClean: "Sin registro de siniestro total",
    writeOffFlagged: "Revisión requerida",
    writeOffModalTitle: "Verificación de siniestro total",
    writeOffScope: "Cat S · Cat N · Cat A · Cat B",
    yearLabel: "año",
    yearPlural: "años",
    yearSingular: "año",
    yearlyBreakdownTitle: "Desglose anual",
    yearsLabel: "años",
    yourLeverageTitle: "Tu poder de negociación",

    riskLevel_HIGH: "ALTO",
    riskLevel_MEDIUM: "MEDIO",
    riskLevel_LOW: "BAJO",
    errorInvalidPlateChars: "En las matrículas del Reino Unido solo se permiten letras y números.",
    legalEnNotice: "Este documento legal está redactado en inglés. El Servicio Worthify se opera desde el Reino Unido y se rige por la legislación británica. Contacte con support@worthify.co.uk para cualquier aclaración.",
    ninaButtonLabel: "Pregunta a Nina — Powered by Pine",
    ninaHeaderTitle: "Nina — Tu copiloto de compra de coche",
    poweredByPine: "Powered by Pine",
    ninaGreeting: "¡Hola! He leído tu informe del vehículo {reg}. ¿Quieres saber si este coche merece la pena? Pregúntame.",
    ninaInputPlaceholder: "Pregunta a Nina…",
    ninaCallPitch: "¿Quieres que llame al vendedor y negocie el precio?",
    ninaCallSellerCta: "Llamar al vendedor — £2,99",
    ninaCalling: "Nina está llamando al vendedor…",
    ninaCallDone: "Llamada completada",
    ninaCallMockSummary: "El vendedor considera £5.700 (de £6.000). Pide que llames esta noche para confirmar.",

    // ── Premium: datos reales del registro (Vehicle Data Global) ──
    gvdSourceNote: "Datos en vivo del registro DVLA",
    accidentSourceNote: "Datos en vivo de MIAFTR + historial DVLA del vehículo",
    miaftrSourceNote: "Datos en vivo de MIAFTR (registro antifraude de aseguradoras)",
    financeSourceNote: "Datos en vivo del registro HPI / Experian (financiación)",
    ownersKeeperLabel: "Titular",
    ownersSinceLabel: "desde",
    registryChecksTitle: "Comprobaciones del registro DVLA",
    importedFlagLabel: "Importado",
    importOutsideEuLabel: "Importado de fuera de la UE",
    importExportedLabel: "Exportado",
    importScrappedLabel: "Desguazado",
    ukSuppliedLabel: "Entregado en Reino Unido",
    flaggedLabel: "Señalado",
    notFlaggedLabel: "Sin registro",
    liveValuationTitle: "Valoración de mercado en vivo",
    valDealerForecourt: "Precio en concesionario",
    valPrivateClean: "Venta privada (muy buen estado)",
    valPartExchange: "Entrega a cambio",
    valAuction: "Subasta",
    valMileageNote: "Valorado con {miles} millas · datos del sector en vivo",
    tyreFitmentTitle: "Neumáticos de fábrica",
    tyreFrontLabel: "Delantero",
    tyreRearLabel: "Trasero",
    priceEvalLabel: "Evaluación del precio",
    mileageTileLabel: "Kilometraje",
    dvlaSubtitle: "Agencia de Licencias de Conductores y Vehículos",
    dvsaSubtitle: "Agencia de Estándares de Conductores y Vehículos",
    dvsaOfficialData: "Datos MOT oficiales",
    poweredBy: "Powered by",
    gvdSubtitle: "Socio de datos de vehículos comerciales",
    hpiSubtitle: "Más datos que un HPI check estándar",
    errorInvalidRegistration: "Esa matrícula no parece correcta — compruébala e inténtalo de nuevo.",

};
